import { SettingsBreadcrumb } from '@/components/breadcrumbs';
import { SettingsPage } from '@/components/settings/settings-page';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const settingsSearchSchema = z.object({
  tab: z.enum(['affichage', 'systeme']).catch('affichage'),
});

export const Route = createFileRoute('/settings')({
  validateSearch: (search): z.infer<typeof settingsSearchSchema> =>
    settingsSearchSchema.parse(search),
  component: SettingsRoute,
  staticData: { breadcrumb: SettingsBreadcrumb },
});

function SettingsRoute() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: '/settings' });
  return (
    <SettingsPage
      tab={tab}
      onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
    />
  );
}
